import { z } from 'zod'

// App-wide knobs for the board ETA list (POST /api/v1/eta/jobs). One row,
// edited by admins; read on every board-ETA request.

const intInRange = (min: number, max: number) => z.number().int().min(min).max(max)

export const etaSettingsSchema = z.object({
  moveThresholdMetres: intInRange(50, 50_000),
  refreshMinutes: intInRange(1, 60),
  gpsMaxAgeMinutes: intInRange(5, 120),
  callsPerMinute: intInRange(1, 3000),
  kestrelTrackerEnabled: z.boolean().default(false),
  kestrelBoardEnabled: z.boolean().default(false),
})
export type EtaSettings = z.infer<typeof etaSettingsSchema>

/** A settings save. A switch left out keeps its stored value, so clients that predate it can't turn it off. */
export const etaSettingsUpdateSchema = etaSettingsSchema.extend({
  kestrelTrackerEnabled: z.boolean().optional(),
  kestrelBoardEnabled: z.boolean().optional(),
})
export type EtaSettingsUpdate = z.infer<typeof etaSettingsUpdateSchema>

export const DEFAULT_ETA_SETTINGS: EtaSettings = {
  moveThresholdMetres: 500,
  refreshMinutes: 5,
  gpsMaxAgeMinutes: 30,
  callsPerMinute: 60,
  kestrelTrackerEnabled: false,
  kestrelBoardEnabled: false,
}

/** Google Routes call counts shown beside the settings. */
export const etaCallCountsSchema = z.object({
  lastHour: z.number().int(),
  failedLastHour: z.number().int(),
  last24Hours: z.number().int(),
})
export type EtaCallCounts = z.infer<typeof etaCallCountsSchema>
